module.exports = "../study/imgs/maps/Nagano/S8/Helth/Mosquito/Nagano_Mosquito_GFDL_RCP26_End.png";